/* FAQ accordion behaviour.
   - Only one item stays open at a time within each .cust-faq group.
   - Native <details>/<summary> drives state, so keyboard/AT/no-JS behaviour
     stays correct; this script only intercepts the click to animate the
     height instead of letting <details> snap open/closed instantly.
   - Animates the <details> element itself between its collapsed height
     (summary only) and its expanded height (summary + answer), using the
     Web Animations API. This avoids the "height: auto can't transition"
     problem without needing a fixed/guessed max-height.
   - The answer text (.cust-faq__a) cross-fades in/out in parallel with the
     height animation, rather than just appearing/disappearing.
   - Respects prefers-reduced-motion by skipping straight to the end state. */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DURATION = 300;
  var EASING = 'ease-in-out';

  document.querySelectorAll('.cust-faq').forEach(function (group) {
    var items = Array.prototype.slice.call(
      group.querySelectorAll(':scope > .cust-faq__item')
    );
    var controllers = items.map(createController);

    items.forEach(function (item, index) {
      var summary = item.querySelector(':scope > .cust-faq__q');
      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.open) {
          controllers[index].close();
          return;
        }

        items.forEach(function (other, otherIndex) {
          if (other !== item && other.open) controllers[otherIndex].close();
        });
        controllers[index].open();
      });
    });
  });

  function createController(item) {
    var summary = item.querySelector(':scope > .cust-faq__q');
    var content = item.querySelector(':scope > .cust-faq__a');
    var heightAnimation = null;
    var opacityAnimation = null;

    function collapsedHeight() {
      return summary.offsetHeight + 'px';
    }

    function expandedHeight() {
      return item.scrollHeight + 'px';
    }

    function animate(startHeight, endHeight, startOpacity, endOpacity, onFinish) {
      if (heightAnimation) heightAnimation.cancel();
      if (opacityAnimation) opacityAnimation.cancel();

      if (prefersReducedMotion.matches) {
        onFinish();
        return;
      }

      item.style.overflow = 'hidden';
      item.style.height = startHeight;
      content.style.opacity = startOpacity;

      heightAnimation = item.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING }
      );
      opacityAnimation = content.animate(
        { opacity: [startOpacity, endOpacity] },
        { duration: DURATION, easing: EASING }
      );

      heightAnimation.onfinish = function () {
        item.style.height = '';
        item.style.overflow = '';
        content.style.opacity = '';
        heightAnimation = null;
        onFinish();
      };
    }

    function open() {
      item.open = true;
      animate(collapsedHeight(), expandedHeight(), 0, 1, function () {});
    }

    function close() {
      var startHeight = expandedHeight();
      animate(startHeight, collapsedHeight(), 1, 0, function () {
        item.open = false;
      });
    }

    return { open: open, close: close };
  }
})();
